<header>
    <button
        type="button"
        class="btn btn-icon btn-transparent float-end btn-logout"
        (click)="authenticationService.logOff()"
        tooltip="{{ 'Log out' | translate }}"
        container="body">
        <sb-inline-svg class="icon" [url]="'/assets/images/exit.svg'"></sb-inline-svg>
    </button>
    <hr />
</header>
<main>
    @if (!createdTicketsData.length) {
        <p class="mt-5">
            {{ 'Select the email which you want to covert to a support ticket in Socialboards' | translate }}
        </p>
        <a (click)="openForm.emit()">{{ 'or use current selected email' | translate }}</a>
    } @else {
        <p class="mt-5 text-start">{{ 'This email has already been sent to Socialboards:' | translate }}</p>

        @for (ticket of createdTicketsData; track ticket) {
            <p class="text-start">
                <a class="link" [href]="ticket.link" target="_blank">
                    #{{ ticket.ticketId }} in {{ ticket.displayName }} >>
                </a>
            </p>
        }
        <button class="btn btn-primary mt-5" (click)="openForm.emit()">{{ 'Create new' | translate }}</button>
    }
</main>
